import React, { useState } from "react";
import {
  CardWrapper,
  DeleteIcon,
  ThreeDotsContainer,
  UpdateIcon,
} from "./style";
import { Image } from "antd";
import { FiMoreVertical } from "react-icons/fi";
import { FiEdit } from "react-icons/fi";
import { FiTrash2 } from "react-icons/fi";

export default ({ data, handleUpdate, handleDelete }) => {
  const [threeDotsClicked, setThreeDotsClicked] = useState(false);

  return (
    <CardWrapper>
      {threeDotsClicked && (
        <ThreeDotsContainer
          onMouseOver={() => setThreeDotsClicked(true)}
          onMouseOut={() => setThreeDotsClicked(false)}
        >
          <UpdateIcon onClick={() => handleUpdate(data)}>
            <FiEdit /> Tahrirlash
          </UpdateIcon>
          <DeleteIcon
            onClick={() => {
              handleDelete(data?.id);
            }}
          >
            <FiTrash2 /> O‘chirish
          </DeleteIcon>
        </ThreeDotsContainer>
      )}

      <div className="card-header">
        <span>Slayder {data.idx}</span>
        <FiMoreVertical
          viewBox="0 0 7 24"
          className="three-dots"
          onClick={() =>
            threeDotsClicked
              ? setThreeDotsClicked(false)
              : setThreeDotsClicked(true)
          }
        />
      </div>
      <div className="image-wrapper">
        <Image
          crossOrigin="anonymous"
          className="ant-image"
          src={data?.img}
          preview={false}
        />
      </div>

      <div className="card-title">
        <div>{data.title}</div>
      </div>
      <div className="card-body">
        <div>{data.desc}</div>
      </div>
    </CardWrapper>
  );
};
